<template>
    <Warning v-if="errorRange"/>
    <div class="form-group row">
        <label class="col-md-3 col-lg-3 col-form-label">
          Seleccione un rango de años
        </label>
        <div class="col-sm-9 col-md-9 col-ls-9">
            <label class="label-date" for="init_date_input">Fecha inicial</label>
            <input class="form-control"
              type="date"
              :value="selected_init_date"
              :min= minDate
              :max= maxDate
              id="init_date_input"
              ref="init_date_input"
              @change="updateSelectedDates(), Check_Form(), Change_Initial_Year(selected_init_date)"
            />
          <label class="label-date" for="finish_date_input">Fecha final</label>
            <input class="form-control"
              type="date"
              :value="selected_finish_date"
              :min= minDate
              :max= maxDate
              id="finish_date_input"
              ref="finish_date_input"
              @change="updateSelectedDates(), checkRange(), getVariables(), Check_Form(), Change_End_Year(selected_finish_date)"
              />
        </div>
    </div>
 </template>

 <script>
 import Warning from '../../views/WarningRangeOfYears.vue'
 import { mapActions, mapState } from 'vuex'

 export default {
  data () {
    return {
      selected_init_date: "",
      selected_finish_date: "",
    }
  },

  props:{
    initDateDefault: String
  },
  
  inject: ['typology'],

  watch: {
    initDateDefault(newInitDate) {
      this.selected_init_date = newInitDate;
      this.Change_Initial_Year(newInitDate); 
    },
  },

  computed: {
    ...mapState(['minDate', 'maxDate', 'errorRange', 'station_id_selected'])
  },

  methods: {
    ...mapActions(['Activate_Error_Range', 'getDataVariablesForStation', 'Check_Form', 'Change_Initial_Year', 'Change_End_Year']),

    checkRange () {
      if (this.selected_init_date > this.selected_finish_date) {
        this.Activate_Error_Range()
        this.selected_finish_date = ""
      }
    },
    updateSelectedDates(){
      this.selected_init_date = this.$refs.init_date_input.value
      this.selected_finish_date = this.$refs.finish_date_input.value
    },
    getVariables(){
      this.getDataVariablesForStation({
        station_id: this.station_id_selected,
        init_date: this.selected_init_date,
        finish_date: this.selected_finish_date,
        typology: this.typology
      })
    }
  },

  components: {
    Warning
  }
 }

 </script>

 <style scoped>
 .col-form-label {
  font-family: "Ancizar-regular", Helvetica, Arial;
 }

 .form-control {
  font-family: "Ancizar-regular", Helvetica, Arial;
  font-size: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  height: 2.5rem;
 }
 .form-control::-webkit-scrollbar {
  display: none;
 }
 .label-date{
  font-family: "Ancizar-regular", Helvetica, Arial;
  font-size: 0.95rem;
  margin-top: 0.4rem;
}

 @media (max-width: 769px) {
  .col-form-label,
  .col-sm-9 {
    width: 100% !important;
  }
 }
 </style>
